import React, { useEffect, useState, useCallback } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { useLocation } from "react-router-dom";
import api from "../api/axios";
import { useAuth } from "../context/AuthContext";

const CategoryPreferencePopup = () => {
    const location = useLocation();
    const { isAuthenticated, loading } = useAuth();

    const [visible, setVisible] = useState(false);
    const [categories, setCategories] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const [saving, setSaving] = useState(false);

    const fetchCategories = useCallback(async () => {
        try {
            const res = await api.get("/CategoryRoutes/customer/categories");

            if (res.data?.success) {
                setCategories(res.data.data || []);
            }
        } catch (error) {
            console.warn("Category fetch failed:", error?.message || error);
        }
    }, []);

    const checkPreference = useCallback(async () => {
        try {
            if (loading) return;

            if (!isAuthenticated) {
                setVisible(false);
                return;
            }

            const res = await api.get(
                "/customerProfileRoutes/customer/category-preferences/status"
            );

            if (res.data?.success && !res.data.has_set_preference) {
                await fetchCategories();
                setVisible(true);
            } else {
                setVisible(false);
            }
        } catch (error) {
            setVisible(false);
            console.warn("Preference status check failed:", error?.message || error);
        }
    }, [isAuthenticated, loading, fetchCategories]);

    useEffect(() => {
        checkPreference();
    }, [checkPreference, location.pathname]);

    const toggleCategory = (categoryId) => {
        setSelectedIds((prev) =>
            prev.includes(categoryId)
                ? prev.filter((id) => id !== categoryId)
                : [...prev, categoryId]
        );
    };

    const savePreferences = async () => {
        if (selectedIds.length === 0) return;

        try {
            setSaving(true);

            const res = await api.post(
                "/customerProfileRoutes/customer/category-preferences/set",
                {
                    category_ids: selectedIds,
                }
            );

            if (res.data?.success) {
                setVisible(false);
                setSelectedIds([]);
                window.dispatchEvent(new Event("categoryPreferenceUpdated"));
            }
        } catch (error) {
            console.warn("Preference save failed:", error?.message || error);
        } finally {
            setSaving(false);
        }
    };

    return (
        <Dialog
            visible={visible}
            modal
            closable={false}
            draggable={false}
            style={{ width: "50vw" }}
            className="px-0 selectcat_dilog"
            onHide={() => {}}
        >
            <div className="text-center pb-3 dialog-header">
                <h4 className="text-white">Choose your preferred categories</h4>
                <p className="text-white">
                    Select the categories you want to see more often.
                </p>
            </div>

            <div className="category-box">
                <ul className="category-list">
                    {categories.map((cat) => {
                        const active = selectedIds.includes(cat.category_id);

                        return (
                            <li
                                key={cat.category_id}
                                className={`category-item ${active ? "active" : ""}`}
                            >
                                <div
                                    className="category-content"
                                    onClick={() => toggleCategory(cat.category_id)}
                                >
                                    <Checkbox
                                        inputId={`cat-${cat.category_id}`}
                                        checked={active}
                                        onChange={() => toggleCategory(cat.category_id)}
                                        className="selectCheckbox"
                                    />

                                    <img
                                        src={cat.image_url}
                                        alt={cat.category_name}
                                        className="category-img"
                                    />

                                    <label htmlFor={`cat-${cat.category_id}`}>
                                        {cat.category_name}
                                    </label>
                                </div>
                            </li>
                        );
                    })}
                </ul>
            </div>

            <div
                className="text-end p-3 dialog-footer"
                style={{ background: "#0b0b0b" }}
            >
                <Button
                    label="Save Preferences"
                    loading={saving}
                    disabled={selectedIds.length === 0 || saving}
                    onClick={savePreferences}
                    className="custbuttonpink billInfo"
                />
            </div>
        </Dialog>
    );
};

export default CategoryPreferencePopup;